import { render } from "./CrearArea.vue?vue&type=template&id=37ba2cd0&scoped=true"
import script from "./CrearArea.vue?vue&type=script&lang=js"
export * from "./CrearArea.vue?vue&type=script&lang=js"

import "./CrearArea.vue?vue&type=style&index=0&id=37ba2cd0&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ba2cd0"]])

export default __exports__